// import axios from 'axios';

// const API_URL = 'http://localhost:5000/api';

// const api = axios.create({
//     baseURL: API_URL,
//     withCredentials: true
// });

// export const signup = async (userData) => {
//     const response = await api.post('/signup', userData);
//     return response.data;
// };

// export const login = async (credentials) => {
//     const response = await api.post('/login', credentials);
//     return response.data;
// };

// export const verifyAuth = async () => {
//     const response = await api.get('/verify');
//     return response.data;
// };

// export const logout = async () => {
//     const response = await api.post('/logout');
//     return response.data;
// };

// export const updateProfile = async (profileData) => {
//     const response = await api.put('/user/profile', profileData);
//     return response.data;
// };

// export const changePassword = async (passwordData) => {
//     const response = await api.put('/user/password', passwordData);
//     return response.data;
// };

// export default api;



import axios from 'axios';

const API_URL = 'http://localhost:5000/api';

const api = axios.create({
    baseURL: API_URL,
    withCredentials: true
});

export const signup = async (userData) => {
    const response = await api.post('/signup', userData);
    return response.data;
};

export const login = async (credentials) => {
    const response = await api.post('/login', credentials);
    return response.data;
};

export const verifyAuth = async () => {
    const response = await api.get('/verify');
    return response.data;
};

export const logout = async () => {
    const response = await api.post('/logout');
    return response.data;
};

export const updateProfile = async (profileData) => {
    const response = await api.put('/user/profile', profileData);
    return response.data;
};

export const updateProfilePic = async (profilePic) => {
    const response = await api.put('/user/profile-pic', { profile_pic: profilePic });
    return response.data;
};

export const changePassword = async (passwordData) => {
    const response = await api.put('/user/password', passwordData);
    return response.data;
};

export default api;